module.exports = __webpack_public_path__ + "img/insta.62f74ad.svg";